module.exports = __webpack_public_path__ + "static/media/draw.9f3e7faf.wav";


//////////////////
// WEBPACK FOOTER
// ./src/sound/draw.wav
// module id = 60
// module chunks = 0